// extracted by mini-css-extract-plugin
export var buttons = "game-summary-module--buttons--6bd5f";
export var container = "game-summary-module--container--3838c";
export var left = "game-summary-module--left--f4daa";
export var logo = "game-summary-module--logo--8910f";
export var sheet = "game-summary-module--sheet--e9826";
export var spin = "game-summary-module--spin--d2c38";